import { ClickCopyTextCell } from "@/features/invoices/components/ClickCopyTextCell";

interface CustomerEmailCellProps {
  email: string | null | undefined;
}

export function CustomerEmailCell({ email }: CustomerEmailCellProps) {
  return (
    <ClickCopyTextCell value={email} resourceLabel="Email" variant="email" />
  );
}
